import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import i18n from "@/config/i18n";
import piHomeMapScreenSta from "./components/pi-home-map-screen-sta/pi-home-map-screen-sta.vue";
import piHomeMapScreenCity from "./components/pi-home-map-screen-city/pi-home-map-screen-city.vue";
// import piHomeMapScreenMch from "./components/pi-home-map-screen-mch/pi-home-map-screen-mch.vue";
import piHomeMapScreenPile from "./components/pi-home-map-screen-pile/pi-home-map-screen-pile.vue";
import piHomeMapScreenScale from "./components/pi-home-map-screen-scale/pi-home-map-screen-scale.vue";
import piHomeMapScreenOther from "./components/pi-home-map-screen-other/pi-home-map-screen-other.vue";
import { State } from "vuex-class";
let PiHomeMmapScreen = class PiHomeMmapScreen extends Vue {
    constructor() {
        super(...arguments);
        this.inputValue = "";
        this.active = "";
        this.formInline = {
            type: "1",
            oprPkId: "",
            oprPkIdList: [],
            merchantPkIdList: [],
            pileNumMaxValue: "",
            pileNumMinValue: "",
            powerMaxValue: "",
            powerMinValue: "",
            provinceId: "",
            cityId: "",
            regionId: "",
            deviceTypeList: [],
            staSizeList: [],
            netDirectionList: [],
            staActivity: [],
            staStatusList: [],
        };
        this.typeList = [
            { label: i18n.t("homeMap.normalSearch"), value: "1" },
            { label: i18n.t("homeMap.advancedSearch"), value: "2" },
        ];
        this.typeObj = {
            1: i18n.t("homeMap.normalSearch"),
            2: i18n.t("homeMap.advancedSearch"),
        };
    }
    // private provinceName = "";
    // private cityName = "";
    // private regionName = "";
    /**
     * 普通搜索聚焦打开列表
     */
    inputFocus() {
        this.$refs.piHomeMapScreenSta.openSearch();
    }
    /**
     * 返回
     */
    goBackClick() {
        this.$emit("goBack");
    }
    /**
     * 普通/高级搜索选择
     */
    tyeClick(val) {
        this.formInline.type = val;
    }
    /**高级条件选择 */
    formChange(data) {
        this.formInline = Object.assign(this.formInline, data);
        this.queryClick();
    }
    /**
     * 重置
     */
    resetClick() {
        for (let i in this.formInline) {
            if (typeof this.formInline[i] == "string") {
                if (i != "oprPkId" && i != "type") {
                    this.formInline[i] = "";
                }
            }
            else {
                this.formInline[i] = [];
            }
        }
        this.$refs.piHomeMapScreenCity.resetting();
        // (this.$refs.piHomeMapScreenMch as any).resetting();
        this.$refs.piHomeMapScreenPile.resetting();
        this.$refs.piHomeMapScreenScale.resetting();
        this.$refs.piHomeMapScreenOther.resetting();
        this.queryClick();
    }
    /**
     * 查询
     */
    queryClick() {
        let formInline = { ...this.formInline };
        if (formInline.staActivity.indexOf("1") != -1 &&
            formInline.staActivity.length == 1) {
            formInline.staActivity = true;
        }
        else if (formInline.staActivity.indexOf("2") != -1 &&
            formInline.staActivity.length == 1) {
            formInline.staActivity = false;
        }
        else {
            formInline.staActivity = "";
        }
        this.active = "";
        this.$emit("search", formInline);
    }
    /**
     * 普通搜索结果
     */
    screenStaList(list) {
        this.$emit("screen-sta-name", list);
    }
    /**
     * 普通搜索结果
     */
    screenStaClick(data) {
        this.$emit("screen-sta-name-click", data);
    }
};
__decorate([
    State("sys")
], PiHomeMmapScreen.prototype, "sys", void 0);
__decorate([
    Prop({
        default: () => {
            return [];
        },
    })
], PiHomeMmapScreen.prototype, "allMarkerList", void 0);
PiHomeMmapScreen = __decorate([
    Component({
        components: {
            "pi-home-map-screen-sta": piHomeMapScreenSta,
            "pi-home-map-screen-city": piHomeMapScreenCity,
            // "pi-home-map-screen-mch": piHomeMapScreenMch,
            "pi-home-map-screen-pile": piHomeMapScreenPile,
            "pi-home-map-screen-scale": piHomeMapScreenScale,
            "pi-home-map-screen-other": piHomeMapScreenOther,
        },
    })
], PiHomeMmapScreen);
export default PiHomeMmapScreen;
